/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Req3Inputs */

const en_wc_on_req3 = /** @type {(inputs: Wc_On_Req3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the editor looks wrong or blank, add ?webgl to the address to force the WebGL2 renderer.`)
};

/**
* | output |
* | --- |
* | "If the editor looks wrong or blank, add ?webgl to the address to force the WebGL2 renderer." |
*
* @param {Wc_On_Req3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_req3 = /** @type {((inputs?: Wc_On_Req3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Req3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_req3(inputs)
});
export { wc_on_req3 as "wc.on.req3" }